import { useEffect, useState, useRef } from 'react'
import AddressLink from './AddressLink'
import Footer from './Footer'
import { Section } from './Section'
import { Subsection } from './Subsection'
import { Modal } from './Modal'
import { Navigation } from './Navigation'
import { SuperHeroSection } from './SuperHeroSection'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useOutsideClick } from '../hooks/useOutsideClick'
import { useVfxClasses } from '../hooks/useVfxClasses'
import {
  Features,
  Technik,
  TechnikFeatures,
  Awards,
  AwardInfosec,
  AwardOpensource,
  AwardGuteverwaltung,
  AwardGesundheitsstadt,
  BuchDigitalisierung,
  OpenCode,
  Kontakt,
  Impressum,
  Datenschutz,
  Modules
} from '../_content'

const InfosecImage = () => (
    <img src="/images/content/infosec-award.png" alt="Infosec Award" className="subsection-image"/>
);
const OpensourceImage = () => (
    <img src="/images/content/open-source-wettbewerb.png" alt="Preis Open Source Wettbewerb" className="subsection-image"/>
);
const GuteverwaltungImage = () => (
    <img src="/images/content/preis-fuer-gute-verwaltung.png" alt="Preis für Gute Verwaltung" className="subsection-image"/>
);
const GesundheitsstadtImage = () => (
    <img src="/images/content/award-fuer-gesundheitsstadt.png" alt="Preis für Gesundheitsstadt" className="subsection-image"/>
);
const BuchDigitalisierungImage = () => (
    <img src="/images/content/buch-digitalisierung.png" alt="Buch Digitalisierung" className="subsection-image"/>
);

const Main = () => {
  const [showImpressum, setShowImpressum] = useState(false)
  const [showDatenschutz, setShowDatenschutz] = useState(false)
  const [navOpen, setNavOpen] = useState(false)

  const { mainClass, headerClass } = useVfxClasses()

  const ref = useRef()

  const outSideClick = () => {
    setNavOpen(false)
    closeAllModals()
  }

  useOutsideClick(ref, () => outSideClick())

  const closeAllModals = () => {
    setShowImpressum(false)
    setShowDatenschutz(false)  
  }

  useEffect(() => {
    // AOS.init({ anchorPlacement: 'top-bottom', offset: 160, easing: 'ease-in-out-cubic', duration: 800 })
    AOS.init({ anchorPlacement: 'top-bottom', offset: 280, easing: 'ease-in-out-cubic', duration: 800 })
  }, [])

  return (
    <>
      {/* Header */}
        <header className={['header py-2 px-6 sm:py-4', headerClass].filter(Boolean).join(' ')}>
          <div className="max-w-6xl mx-auto flex justify-between items-end">
            <div className="flex items-center">
              <img src="images/ga-ffm_logo.svg" alt="GA-Lotse Logo" className="h-12"/>
            </div>
          {/* Navigation */}
            <Navigation
              navOpen={navOpen}
              onToggle={() => setNavOpen((prev) => !prev)}
              onClose={() => setNavOpen(false)}
              navRef={ref}
            />
          </div>
        </header>
    <main className={mainClass || undefined}>
      {/* SuperHero Section — wraps Hero Intro + Background Info (shared background + vignette) */}
        <SuperHeroSection />

      {/* Key Features Section */}
        <Section id="features" subline="Features" title="GA-Lotse im Einsatz" dataAos="fade-up" >
          <Features/>
        </Section>

      {/* Technical Background Section */}
        <Section id="technical" subline="Technik" title="Modernste Technologien" invertedHeaderColors invertedTextColor dataAos="fade-up">
          <Technik/>
        </Section>
      {/* Technical Fatures Section */}
        <Section id="technical-features" hideHeader dataAos="fade-up">
          <TechnikFeatures/>
        </Section>

      {/* Modules Section */}
        <Section id="modules" subline="Module" title="Flexibel erweiterbar für unterschiedliche Anwendungsbereiche" dataAos="fade-up">
          <Modules/>
        </Section>

      {/* the Timeline will be commented for the moment, because it content false infos  */}
      {/* Timeline Section */}
      {/* <Timeline dataAos="fade-up" dataAosDelay="100" />*/}

      {/* Awards Section */}
      <Section id="awards" subline="Auszeichnungen" title="Unsere Arbeit überzeugt" dataAos="fade-up" dataAosDelay="100" className="py-8 px-6" isDarkBg={true}>
        <Awards/>
          <Subsection 
            id="award-infosec" 
            subline="InfoSec Impact Award"
            title="für IT-Sicherheitslösungen"  
            dataAos="fade-up" 
            dataAosDelay="200"
            image={<InfosecImage />} 
          >
            <AwardInfosec/>
          </Subsection>
          <Subsection 
            id="award-opensource" 
            subline="Open Source Wettbewerb"
            title="Kategorie „Fachverfahren“"  
            dataAos="fade-up" 
            dataAosDelay="200"
            image={<OpensourceImage />} 
            imageOnRight={true}
            >
            <AwardOpensource/>
          </Subsection>
          <Subsection 
            id="award-guteverwaltung" 
            subline="Preis für gute Verwaltung" 
            title="Unter den Gewinnern"
            dataAos="fade-up" 
            dataAosDelay="200"
            image={<GuteverwaltungImage />} 
          >
            <AwardGuteverwaltung/>
          </Subsection>
          <Subsection
              id="award-gesundheitsstadt"
              subline="Digital Award durch Gesundheitsstadt Berlin e.V."
              title="Gewinner"
              dataAos="fade-up"
              dataAosDelay="200"
              image={<GesundheitsstadtImage />}
              imageOnRight={true}
          >
            <AwardGesundheitsstadt/>
          </Subsection>
      </Section>

      {/* Book Section */}
        <Section id="book" subline="Buch Digitalisierung" title="So gelingt die Transformation wirklich" dataAos="fade-up" dataAosDelay="200" image={<BuchDigitalisierungImage/>}>
          <BuchDigitalisierung/>
        </Section>

      {/* OpenCode Section */}
        <Section id="opencode" subline="Open Source" title="Auf zu GA-Lotse auf OpenCoDE" isDarkBg dataAos="fade-up" dataAosDelay="200">
          <OpenCode/>
        </Section>

      {/* Contact Form Section */}
        <Section id="contact" subline='Kontakt' title="So erreichen Sie uns" dataAos="fade-up" dataAosDelay="200">
          <Kontakt/>
          <AddressLink/>
        </Section>

      {/* Footer */}
        <Footer setShowImpressum={setShowImpressum} setShowDatenschutz={setShowDatenschutz}/>
    </main>

      {/* Imprint Modal */}
        {
          showImpressum && (
            <Modal title="Impressum" onClose={closeAllModals} containerRef={ref}>
              <Impressum/>
            </Modal>
          )
        }

      {/* Privacy Modal */}
        {
          showDatenschutz && (
            <Modal title="Datenschutzerklärung" onClose={closeAllModals} containerRef={ref}>
              <Datenschutz/>
            </Modal>
          )
        }
    </>
  )
}

export default Main;